import styled from 'styled-components'

import { PolicyItem } from 'components/Lists'

export const PolicyTextItem = styled(PolicyItem)`
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: auto auto;
	margin-bottom: 24px;
`
